import { Typography, } from "@bracket/ui";
import type { ColateralBalances, } from "@types";
import type { FunctionComponent, } from "react";
import { cst, } from "@formatters";

export type BalanceCardProps = ColateralBalances & { };


export const BalanceCard: FunctionComponent<BalanceCardProps> = ({
	title,
	count,
	symbol,
	rate,
}) => {
	const display = `${cst(count, symbol === "USDC" ? 2 : 5)}`;
	return (
		<>
			<Typography variant="paragraphLG" color="var(--text-subheading)">
				{title}
			</Typography>

			<Typography variant="paragraphLG" color="var(--text-subheading)" textAlign="right">
				{display}
			</Typography>
			{
				symbol !== "USDC" && (
					<Typography variant="paragraphLG" color="var(--text-subheading)" textAlign="right">
						{rate.toFixed(8)}
					</Typography>
				)
			}
		</>
	);
};
